export default __webpack_public_path__ + "static/media/jks-logo.00fdda9f.svg";